import { visuallyHiddenStyles, Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import MinusIcon from "@/icons/MinusIcon";
import PlusIcon from "@/icons/PlusIcon";
import InlineImage from "../InlineImage";
import { iconCss, imgButtonCss } from "../ProseMirrorImageBlock.style";

const propTypes = {
  currentImage: PropTypes.object,
  isImageExpanded: PropTypes.bool,
  toggleZoom: PropTypes.func,
};

const ZoomableImage = ({ currentImage, isImageExpanded, toggleZoom }) => {
  const ariaProps = { "aria-expanded": isImageExpanded };

  const buttonProps = {
    onClick: toggleZoom,
    flavor: Button.flavors.incognito,
    ariaProps,
    __cssFor: { root: imgButtonCss },
  };

  const screenReaderText = isImageExpanded ? "Zoom out" : "Zoom in";
  const Icon = isImageExpanded ? MinusIcon : PlusIcon;

  return (
    <Button {...buttonProps}>
      <InlineImage currentImage={currentImage} />
      <div title={isImageExpanded ? "Zoom out" : "Zoom in"} css={iconCss}>
        <Icon />
      </div>
      <span css={visuallyHiddenStyles}>{screenReaderText}</span>
    </Button>
  );
};

ZoomableImage.propTypes = propTypes;

export default ZoomableImage;
